import { render, staticRenderFns } from "./DeliveryTrace.vue?vue&type=template&id=1c5453a8"
import script from "./DeliveryTrace.vue?vue&type=script&lang=js"
export * from "./DeliveryTrace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports